import React, {Component} from 'react';
import Card from '../../common/card-grid/Card';
import {
  Button,
  Wrapper,
  ContainerTitle,
  List,
  Row,
  RowTitle,
  Item,
  ItemTitle,
  Input,
  selectAll,
  selectNone,
  select,
  isSelected,
  getFilteredData,
} from '../../settings/Select';
import {FILTER_NONE, FILTER_ALL} from '../../../constants/filters';
import gql from 'graphql-tag';
import {Query, withApollo} from 'react-apollo';
import PRODUCTSTATES from '../../../constants/productstates';
import Loading from '../Loading';
import Error from '../Error';
import DeleteProductState from '../DeleteProductState';

const productStatesSettingsQuery = gql`
  query productStatesSettings($productStatesInput: ProductStatesQueryInput!, $settingsInput: SettingsQueryInput!) {
    productStates(input: $productStatesInput) {
      id
      product {
        id
        name
        time
        workplace {
          id
          name
        }
      }
      range {
        start
        end
      }
      averageWorkerCount
      difference
      rejectCount
      productiveTime
      pauseTime
      workplaceDisfunctionTime
    }
    settings(input: $settingsInput) {
      id
      productStates {
        type
        ids
      }
    }
  }
`;

class ProductStatesFilter extends Component {
  state = {
    search: '',
    scrollOffset: 0,
  };

  handleScrollOffset = (event) => {
    this.setState({scrollOffset: event.currentTarget.scrollTop});
  };

  render() {
    const {favoriteId, periodAnchor} = this.props;
    return (
      <Query
        query={productStatesSettingsQuery}
        variables={{productStatesInput: {periodAnchor}, settingsInput: {favoriteId}}}>
        {({loading, error, data, refetch}) => {
          if (loading)
            return (
              <Card>
                <Loading />
              </Card>
            );
          if (error) return <Error>{error.message}</Error>;
          const filterProductStates = getFilteredData(data.productStates, this.state.search).sort((a, b) => {
            if (a.id > b.id) return -1;
            if (a.id < b.id) return 1;
            return 0;
          });
          return (
            <Card>
              <Wrapper>
                <Button
                  active={data.settings.productStates.type === FILTER_ALL}
                  onClick={() => selectAll(this, data.productStates, 'id', 'productStates')}>
                  {PRODUCTSTATES.find((t) => t.key === FILTER_ALL).label}
                </Button>
                <Button
                  active={data.settings.productStates.type === FILTER_NONE}
                  onClick={() => selectNone(this, data.productStates, 'id', 'productStates')}>
                  {PRODUCTSTATES.find((t) => t.key === FILTER_NONE).label}
                </Button>
              </Wrapper>
              <Input
                placeholder={'Search ProductStates'}
                value={this.state.productStates}
                onChange={(e) => this.setState({search: e.target.value})}
              />
              <ContainerTitle>
                {filterProductStates && filterProductStates.length > 0 && (
                  <RowTitle>
                    <ItemTitle size={1 / 15}>ProductStateId</ItemTitle>
                    <ItemTitle size={2 / 15}>Arbeitsplatz</ItemTitle>
                    <ItemTitle size={5 / 30}>Produkt</ItemTitle>
                    <ItemTitle size={2 / 15}>Startdatum inkl. Uhrzeit</ItemTitle>
                    <ItemTitle size={1 / 15}>Vorgabezeit</ItemTitle>
                    <ItemTitle size={1 / 15}>Ø Anzahl MA</ItemTitle>
                    <ItemTitle size={1 / 15}>Differenz</ItemTitle>
                    <ItemTitle size={1 / 15}>Ausschuss</ItemTitle>
                    <ItemTitle size={1 / 15}>Produktivzeit (alle MA)</ItemTitle>
                    <ItemTitle size={1 / 15}>Pausenzeit</ItemTitle>
                    <ItemTitle size={1 / 15}>Linienstörungszeit</ItemTitle>
                    <ItemTitle size={1 / 30}>&nbsp;</ItemTitle>
                  </RowTitle>
                )}
                <List
                  //showheader={1}
                  scrollOffset={this.state.scrollOffset}
                  itemCount={filterProductStates.length}
                  onScroll={(offset, e) => this.handleScrollOffset(e)}
                  renderItem={({index, style}) => (
                    <Row
                      style={style}
                      key={index}
                      onClick={() =>
                        select(
                          this,
                          data.settings.productStates,
                          filterProductStates[index].id,
                          data.productStates,
                          'id',
                          'productStates'
                        )
                      }
                      selected={isSelected(data.settings.productStates, filterProductStates[index].id)}>
                      <Item size={1 / 15}>{filterProductStates[index].id}</Item>
                      <Item size={2 / 15}>{filterProductStates[index].product.workplace.name}</Item>
                      <Item size={5 / 30}>{filterProductStates[index].product.name}</Item>
                      <Item size={2 / 15}>{filterProductStates[index].range.start}</Item>
                      <Item size={1 / 15}>{filterProductStates[index].product.time}</Item>
                      <Item size={1 / 15}>{filterProductStates[index].averageWorkerCount}</Item>
                      <Item size={1 / 15}>{filterProductStates[index].difference}</Item>
                      <Item size={1 / 15}>{filterProductStates[index].rejectCount}</Item>
                      <Item size={1 / 15}>{filterProductStates[index].productiveTime}</Item>
                      <Item size={1 / 15}>{filterProductStates[index].pauseTime}</Item>
                      <Item size={1 / 15}>{filterProductStates[index].workplaceDisfunctionTime}</Item>
                      <Item size={1 / 30}>
                        <DeleteProductState id={filterProductStates[index].id} refetch={refetch} />
                      </Item>
                    </Row>
                  )}
                />
              </ContainerTitle>
            </Card>
          );
        }}
      </Query>
    );
  }
}

export default withApollo(ProductStatesFilter);
